import { render, staticRenderFns } from "./TranslateControl.vue?vue&type=template&id=c9cad984"
import script from "./TranslateControl.vue?vue&type=script&lang=js"
export * from "./TranslateControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports